import React, { useEffect, useState,useContext } from 'react'
import { Form, Field } from 'react-final-form'
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { getFormErrorMessage } from '../utilities/FormHelpers'
import { UserContext } from '../UserContext.js';

/*
    props:
    values {}
    onSubmit (data)
*/
export const SectionForm = (props) => {
	const [levelOptions, setLevelOptions] = useState([]);
	const user = useContext(UserContext)
	useEffect(() => {
		user.apiCall(`sectionformoptions`)
			.then((res) => setLevelOptions(res.data))
	}, [])

	const validate = (formData) => {
		let errors = {};

		if(!formData.sectionName || formData.sectionName === "") {
			errors.sectionName = "Name required";
		}

		if(!formData.levelGuid) {
			errors.levelGuid = "Level required";
		}

		return errors;
	}

	return (
		<Form
			onSubmit={props.onSubmit}
			validate={validate}
			initialValues={props.values}
			render={({handleSubmit}) => (
				<form onSubmit={handleSubmit} className="master-form">
					<Field name="sectionName"
						render={({ input, meta }) => (
							<div>
								<span className="p-float-label">
									<InputText {...input}
										id="sectionName"
									/>
									<label htmlFor='sectionName'>Name:&nbsp;</label>
								</span>
								{getFormErrorMessage(meta)}
							</div>
						)}/>
					<Field name="levelGuid"
						render={({ input, meta }) => (
							<div>
								<span className="p-float-label">
									<Dropdown {...input}
										id="levelGuid"
										options={levelOptions}
										optionLabel="label"
									/>
									<label htmlFor='levelGuid'>Level:&nbsp;</label>
								</span>
								{getFormErrorMessage(meta)}
							</div>
						)}/>
					<div className='submit-footer'>
						<Button type="submit" label="Submit" />
					</div>
				</form>
			)}
		/>
	);
}